import React from 'react';

const FilterOption = ({ icon, label, isActive, onClick }) => {
  return (
    <div 
      className={`filter-option ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="filter-icon">
        {icon}
      </div>
      <div className="filter-label">
        {label}
      </div>
    </div>
  );
};

export default FilterOption;
